export function initializeYearDropdown() {
    const yearDropdown = document.getElementById("input_1_12_3");
    if (!yearDropdown) return;

    const currentYear = new Date().getFullYear();
    const maxYear = currentYear + 4;
    
    yearDropdown.innerHTML = "";
    
    const defaultOption = document.createElement("option");
    defaultOption.value = "";
    defaultOption.text = "Year";
    yearDropdown.appendChild(defaultOption);
    
    for (let year = currentYear; year <= maxYear; year++) {
        const option = document.createElement("option");
        option.value = year;
        option.text = year;
        yearDropdown.appendChild(option);
    }
}